import { DatePatternProps } from '../../../types/DatePatternProps';

export const getFormatFromDatePattern =
  (datePattern: DatePatternProps['datePattern']) => (value: string) => {
    if (value === '') return '';

    switch (datePattern) {
      case 'DD': {
        let day = value.slice(0, 2);
        if (day.length === 1 && +day[0] > 3) {
          day = `0${day[0]}`;
        } else if (day.length === 2) {
          // set the lower and upper boundary
          if (Number(day) === 0) {
            day = `01`;
          } else if (Number(day) > 31) {
            day = '31';
          }
        }
        return day;
      }
      case 'MM/YYYY': {
        let month = value.slice(0, 2);
        const year = value.slice(2, 6);
        if (month.length === 1 && +month[0] > 1) {
          month = `0${month[0]}`;
        } else if (month.length === 2) {
          // set the lower and upper boundary
          if (Number(month) === 0) {
            month = `01`;
          } else if (Number(month) > 12) {
            month = '12';
          }
        }
        return `${month}/${year}`;
      }
      case 'YYYY': {
        const year = value.slice(0, 4);
        return year;
      }
      default: {
        throw new Error(`Unsupported date pattern: ${datePattern}`);
      }
    }
  };
